import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { TextFieldSlTp } from './SidebarPendingOrderSlTp'
import { useDebounce } from './useDebounce'
import useSlTp from './useSlTp'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { setStateStopLoss } from '../../../../../store/redusers/orders/actions'
import { useSelector } from 'react-redux'
import { selectStopLossLine } from '../../../../../store/redusers/orders/selectors'

function SlAmountComponent(
	{
		userCurrency,
		stopLossAmount,
		updateSlTp,
		setStopLossSend,
		stopLossUpdate,
		assetId,
		position,
		lastPrice,
		isSuccessOpenTrade,
		setIsSuccessCreate,
		pendingPosition
	}) {

	const { dispatch, theme, t } = useDefaultComponentTools()
	const [state, action] = useSlTp(stopLossUpdate, assetId, position, 'sl', lastPrice)
	const debouncedValue = useDebounce(state.tempValue, 1000)
	const slLine = useSelector(selectStopLossLine)
	const justFirstInit = useRef(false)
	useEffect(() => {
		if (updateSlTp) updateSlTp('sl', +debouncedValue)
		if (setStopLossSend) setStopLossSend(debouncedValue)
		dispatch(setStateStopLoss(debouncedValue))
		if (+lastPrice && +lastPrice === +debouncedValue) {
			action.returnInitialState()
		}
	}, [debouncedValue])

	useEffect(() => {
		if(!justFirstInit.current){
			justFirstInit.current = true
			return
		}
		action.updateValueChart(slLine)
	}, [slLine])

	useEffect(() => {
		if (pendingPosition) {
			setTimeout(() => {
				if (updateSlTp) updateSlTp('sl', state.initialValue)
				if (setStopLossSend) setStopLossSend(state.initialValue)
				dispatch(setStateStopLoss(state.initialValue))
			}, 800)
		}
	}, [state.initialValue])

	useEffect(() => {
		if (isSuccessOpenTrade && setIsSuccessCreate) {
			action.returnInitialState()
			setIsSuccessCreate(false)
		}
	}, [isSuccessOpenTrade])

	return (
		<>
			<Typography variant='px14' sx={{color: theme.palette.text.primary}}>{t('SL')}</Typography>
			<TextFieldSlTp
				// type='number'
				variant='outlined'
				onChange={action.updateValue}
				value={state.tempValue || state.initialValue || ''}
				inputProps={{ 'aria-label': 'Without label' }}
				name={'sl'}
				id='sl'
			/>
			<Box sx={{
				color: '#7C8DA7',
				display: 'flex',
				justifyContent: 'space-between',
				mb: 2
			}}>
				{!stopLossAmount ?
					null : ((state.tempValue && state.tempValue !== '0')
						|| (state.initialValue && state.initialValue !== '0')) &&
					(<>
						<Typography sx={{color: '#7C8DA7'}}>{t('SL Amount:')}</Typography>
						<Typography sx={{color: '#7C8DA7'}}>
							{stopLossAmount + ' ' + userCurrency}
						</Typography>
					</>)
				}
			</Box>
		</>
	)
}

SlAmountComponent.propTypes = {
	assetId: PropTypes.any,
	isSuccessOpenTrade: PropTypes.any,
	lastPrice: PropTypes.any,
	pendingPosition: PropTypes.any,
	position: PropTypes.any,
	setIsSuccessCreate: PropTypes.any,
	setStopLossSend: PropTypes.any,
	stopLossAmount: PropTypes.any,
	stopLossUpdate: PropTypes.any,
	updateSlTp: PropTypes.any,
	userCurrency: PropTypes.any
}

export default SlAmountComponent
